// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./files/SharpGrotesk-Book20.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./files/SharpGrotesk-Bold15.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'SharpGrotesk';
    font-style: normal;
    font-display: swap;
    font-weight: 200;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

@font-face {
    font-family: 'Sharp Grotesk';
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

@font-face {
    font-family: 'Sharp Grotesk';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

@font-face {
    font-family: 'Sharp Grotesk';
    font-style: normal;
    font-display: swap;
    font-weight: 600;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}

@font-face {
    font-family: 'Sharp Grotesk';
    font-style: normal;
    font-display: swap;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}

@font-face {
    font-family: 'Sharp Grotesk';
    font-style: normal;
    font-display: swap;
    font-weight: 900;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/sharpGrotesk/index.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAqH;AACzH;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAqH;AACzH;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAqH;AACzH;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAqH;AACzH;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAqH;AACzH;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAqH;AACzH","sourcesContent":["@font-face {\n    font-family: 'SharpGrotesk';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 200;\n    src: url(./files/SharpGrotesk-Book20.otf) format('opentype'), url(./files/SharpGrotesk-Book20.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Sharp Grotesk';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 300;\n    src: url(./files/SharpGrotesk-Book20.otf) format('opentype'), url(./files/SharpGrotesk-Book20.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Sharp Grotesk';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 400;\n    src: url(./files/SharpGrotesk-Book20.otf) format('opentype'), url(./files/SharpGrotesk-Book20.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Sharp Grotesk';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 600;\n    src: url(./files/SharpGrotesk-Bold15.otf) format('opentype'), url(./files/SharpGrotesk-Bold15.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Sharp Grotesk';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 700;\n    src: url(./files/SharpGrotesk-Bold15.otf) format('opentype'), url(./files/SharpGrotesk-Bold15.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Sharp Grotesk';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 900;\n    src: url(./files/SharpGrotesk-Bold15.otf) format('opentype'), url(./files/SharpGrotesk-Bold15.otf) format('opentype');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
